module.exports = __webpack_public_path__ + "media/app/components/Footer/GoogleStore.8d99ca00.svg";